import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-mat-bottom-sheet',
  templateUrl: './bottom-confirmation-message.component.html',
  styleUrls: ['./bottom-confirmation-message.component.scss']
})
export class BottomConfirmationMessageComponent implements OnInit {

  showData: any;
  isInviteTradee:boolean =false;
  isInviteTenant:boolean =false;
  confirmationMessage: string;
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: {},
    private bottomsheet: MatBottomSheetRef<BottomConfirmationMessageComponent>) { }

  ngOnInit(): void {
    this.showData = this.data;
    this.confirmationMessage = this.showData["message"]
    this.isInviteTradee = this.showData["isInviteTradee"] || false;
    this.isInviteTenant = this.showData["isInviteTenant"] || false;
    console.log("Data :", this.showData["message"],this.isInviteTradee)
  }


  closeBottomSheet(response: boolean) {
    this.bottomsheet.dismiss(response);
  }

  close() {
    this.dismiss();
  }

  dismiss() {
    this.bottomsheet.dismiss();
  }

}
